import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";

const RegLoginModal = ({ regLoginModal, setRegLoginModal }) => {
    const [formData, setFormData] = useState({
        email: "",
        password: "",
    });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const blockedDomains = [
        "yopmail.com",
        "mailinator.com",
        "tempmail.com",
        "temporary-mail.net",
        "temp-mail.org",
        "10minutemail.com",
        "guerrillamail.com",
        "trashmail.com",
        "fakeinbox.com",
        "getnada.com",
        "dispostable.com",
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((p) => ({ ...p, [name]: value }));
        setErrors((p) => ({ ...p, [name]: "" }));
    };

    const validateForm = () => {
        let isValid = true;
        const newErrors = {};

        const emailRegex =
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if (!formData.email) {
            newErrors.email = "Email is required";
            isValid = false;
        } else if (!emailRegex.test(formData.email)) {
            newErrors.email = "Enter a valid email";
            isValid = false;
        } else {
            const domain = formData.email.split("@")[1]?.toLowerCase();
            if (blockedDomains.includes(domain)) {
                newErrors.email = "Disposable emails not allowed";
                isValid = false;
            }
        }

        if (!formData.password) {
            newErrors.password = "Password is required";
            isValid = false;
        } else if (formData.password.length < 6) {
            newErrors.password = "Password must be at least 6 characters";
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);

        const { email, password } = formData;

        const url = `https://backend.mysittivacations.com/api/register-or-login-user?email=${encodeURIComponent(
            email
        )}&password=${encodeURIComponent(password)}`;

        try {
            const res = await fetch(url);
            const data = await res.json();

            if (res.ok) {
                localStorage.setItem('isLoggedIn', 'true');
                localStorage.setItem('userName', data.name);
                localStorage.setItem('token', data.token);
                localStorage.setItem('userEmail', data.email);
                window.location.reload();
                toast.success(data.message || "Success");
                setFormData({ email: "", password: "" });
                setRegLoginModal(false);

            } else {
                toast.error(data.message || "Submission failed");
            }
        } catch (err) {
            toast.error("Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            show={regLoginModal}
            onHide={() => setRegLoginModal(false)}
            centered
            size="xl"
            backdrop="static"
            className="plan-marte-bg"
        >
            <Modal.Body>
                <button
                    className="btn-close plan_smarter_close"
                    onClick={() => setRegLoginModal(false)}
                />

                <div className="plan_smarter">
                    <div className="row">
                        <div className="col-lg-6 d-none d-lg-block" />

                        <div className="col-lg-6">
                            <div className="Plan_smarter_right">
                                <h2>Plan a Smarter Trip—Free Welcome Gift 🎁</h2>
                                <p>
                                    Get our free travel guide with personalized trip ideas + money-saving tips.
                                </p>

                                <form onSubmit={handleSubmit}>
                                    {/* Email */}
                                    <div className="form-group mb-3">
                                        <input
                                            type="email"
                                            name="email"
                                            placeholder="Enter Your Email"
                                            className="form-control"
                                            value={formData.email}
                                            onChange={handleChange}
                                        />
                                        {errors.email && (
                                            <div className="text-danger small">
                                                {errors.email}
                                            </div>
                                        )}
                                    </div>

                                    {/* Password with Show / Hide */}
                                    <div className="form-group mb-3 position-relative">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            name="password"
                                            placeholder="Enter Password"
                                            className="form-control"
                                            value={formData.password}
                                            onChange={handleChange}
                                        />
                                        <span
                                            onClick={() => setShowPassword(!showPassword)}
                                            style={{
                                                position: "absolute",
                                                right: "12px",
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                cursor: "pointer",
                                                fontSize: "14px",
                                                color: "#555",
                                            }}
                                        >
                                            {showPassword ? "Hide" : "Show"}
                                        </span>

                                        {errors.password && (
                                            <div className="text-danger small">
                                                {errors.password}
                                            </div>
                                        )}
                                    </div>

                                    <button
                                        type="submit"
                                        className="submit-btn"
                                        disabled={loading}
                                    >
                                        {loading ? "Submitting..." : "Explore"}
                                    </button>
                                </form>

                                <p className="mt-3">
                                    5k+ travellers have scored our free guide.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default RegLoginModal;
